
import Cookies from 'js-cookie'
/**
 * Functionality to set cookies based on utm params
 */
export default class SetUtmCookies {
    /**
     * @desc Set up utm cookies
     * @param {HTMLElement} el - Element that contains possible validations
     *
     */
    constructor() {
        this.utmSourceCookieValue = Cookies.get('utm_source')

        let inThirtyMinutes = new Date(new Date().getTime() + 15 * 60 * 1000)
        this.cookieOptions = {
            expires: inThirtyMinutes
        }
        this.initialize()
    }

    /**
     * @desc initialize the class functions after global variables are defined
     */
    initialize() {
        if (this.isFirstVisit()) {
            this.setCookies()
        }
    }

    /**
     * @desc checks if the utm source cookie has already been set
     */
    isFirstVisit() {
        if (this.utmSourceCookieValue === undefined || this.utmSourceCookieValue === null) {
            return true
        }
    }

    /**
     * @desc sets the cookies
     */
    setCookies() {
        let searchParams = new URL(window.location.href).searchParams

        let utmSourceParam = searchParams.get('utm_source')

        let utmSourceCookieValue,
            utmMediumCookieValue,
            utmContentCookieValue,
            utmCampaignCookieValue,
            utmTermCookieValue

        if (utmSourceParam !== undefined && utmSourceParam !== null && utmSourceParam !== '') {
            utmSourceCookieValue = utmSourceParam
            utmMediumCookieValue = searchParams.get('utm_medium') || ''
            utmContentCookieValue = searchParams.get('utm_content') || ''
            utmCampaignCookieValue = searchParams.get('utm_campaign') || ''
            utmTermCookieValue = searchParams.get('utm_term') || ''
        } else if (searchParams.get('gclid') !== '' && searchParams.get('gclid') !== null) {
            utmSourceCookieValue = 'Google'
            utmMediumCookieValue = 'Paid-Search'
            utmContentCookieValue = ''
            utmCampaignCookieValue = ''
            utmTermCookieValue = ''
        } else if (document.referrer !== '') {
            utmSourceCookieValue = document.referrer
            utmMediumCookieValue = 'Non-Paid'
            utmContentCookieValue = ''
            utmCampaignCookieValue = ''
            utmTermCookieValue = ''
        } else {
            utmSourceCookieValue = 'Direct'
            utmMediumCookieValue = 'Non-Paid'
            utmContentCookieValue = ''
            utmCampaignCookieValue = ''
            utmTermCookieValue = ''
        }

        Cookies.set('utm_source', utmSourceCookieValue, this.cookieOptions)
        Cookies.set('utm_medium', utmMediumCookieValue, this.cookieOptions)
        Cookies.set('utm_content', utmContentCookieValue, this.cookieOptions)
        Cookies.set('utm_campaign', utmCampaignCookieValue, this.cookieOptions)
        Cookies.set('utm_term', utmTermCookieValue, this.cookieOptions)
    }
}